export enum PAGE_TYPES {
  ARTICLE = 'ARTICLE',
  VIDEO = 'VIDEO',
  RECIPE = 'RECIPE',
  STATIC = 'STATIC'
}
